import {
  aYaraSource,
  aYaraSourcePage,
  mockYaraSourceDetailOperationQuery,
  mockYaraSourcesOperationQuery,
  YaraSource,
} from '__generated__';

export const getMockYaraSourcesOperationQuery_create = (
  yaraSource: Partial<YaraSource>
) => {
  return mockYaraSourcesOperationQuery((_req, res, ctx) => {
    const yaraSources = aYaraSourcePage().objects;
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        yaraSources: aYaraSourcePage({
          objects: [
            ...yaraSources,
            aYaraSource({
              id: 'testId',
              createdBy: 'someone',
              issues: [],
              ...yaraSource,
            }),
          ],
        }),
      })
    );
  });
};

export const getMockYaraSourceDetailOperationQuery_create = (
  yaraSourceDetail: Partial<YaraSource>
) => {
  return mockYaraSourceDetailOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        yaraSource: aYaraSource({
          id: 'testId',
          createdBy: 'someone',
          issues: [],
          rules: {
            __typename: 'YaraRulePage',
            objects: [],
            total: 0,
            hasNextPage: false,
          },
          ...yaraSourceDetail,
        }),
      })
    );
  });
};

export const handlers = [
  mockYaraSourcesOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        yaraSources: aYaraSourcePage(),
      })
    );
  }),
  mockYaraSourceDetailOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        yaraSource: aYaraSource(),
      })
    );
  }),
];
